import { Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { TagsFieldsFragment } from '@api/gql/graphql';
import { TableWrapper } from '@components';

export function TagsTable({ tagsData }: { tagsData: TagsFieldsFragment[] }) {
  return (
    <Stack direction="column" spacing={2}>
      <TagsTableTitle tags={tagsData} />
      <TagsTableContent tags={tagsData} />
    </Stack>
  );
}

function TagsTableTitle({ tags }: { tags: TagsFieldsFragment[] }) {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Typography variant="subtitle2">Tags</Typography>
      <Typography variant="body2" color="text.muted">
        {tags.length} Tag{tags.length > 1 ? 's' : ''}
      </Typography>
    </Stack>
  );
}

function TagsTableContent({ tags }: { tags: TagsFieldsFragment[] }) {
  return (
    <TableWrapper noBackground>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Key</TableCell>
            <TableCell>Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tags.map((tag) => (
            <TableRow key={tag.key}>
              <TableCell>{tag.key}</TableCell>
              <TableCell>{tag.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableWrapper>
  );
}
